import { Navigate } from "react-router-dom";
import { useCurrentUser } from "@/lib/auth";
import EmptyState from "@/components/EmptyState";
import { canSee, firstAllowedPath, type PageKey } from "@/lib/pages";

// Гард конкретной страницы: нет доступа → редирект на первую доступную;
// доступных нет вовсе → заглушка. AuthGate выше гарантирует залогиненность.
export default function PageGuard({
  page,
  children,
}: {
  page: PageKey;
  children: React.ReactNode;
}) {
  const { user } = useCurrentUser();
  if (!user) return null;
  if (canSee(user, page)) return <>{children}</>;
  const first = firstAllowedPath(user);
  if (first) return <Navigate to={first} replace />;
  return (
    <EmptyState
      title="Нет доступа к этой странице"
      hint="Обратитесь к администратору."
    />
  );
}
